import * as React from 'react';
import { forwardRef, useImperativeHandle, useRef, useEffect } from 'react';
import { applyReactStyle } from '../utils/apply-react-style';
import useControl from './use-control';
var GeolocateControl = forwardRef(function (props, ref) {
  var thisRef = useRef({
    props: props
  });
  var ctrl = useControl(function (_ref) {
    var mapLib = _ref.mapLib;
    var gc = new mapLib.GeolocateControl(props);
    gc.on('geolocate', function (e) {
      var _thisRef$current$prop, _thisRef$current$prop2;

      (_thisRef$current$prop = (_thisRef$current$prop2 = thisRef.current.props).onGeolocate) === null || _thisRef$current$prop === void 0 ? void 0 : _thisRef$current$prop.call(_thisRef$current$prop2, e);
    });
    gc.on('error', function (e) {
      var _thisRef$current$prop3, _thisRef$current$prop4;

      (_thisRef$current$prop3 = (_thisRef$current$prop4 = thisRef.current.props).onError) === null || _thisRef$current$prop3 === void 0 ? void 0 : _thisRef$current$prop3.call(_thisRef$current$prop4, e);
    });
    gc.on('outofmaxbounds', function (e) {
      var _thisRef$current$prop5, _thisRef$current$prop6;

      (_thisRef$current$prop5 = (_thisRef$current$prop6 = thisRef.current.props).onOutOfMaxBounds) === null || _thisRef$current$prop5 === void 0 ? void 0 : _thisRef$current$prop5.call(_thisRef$current$prop6, e);
    });
    gc.on('trackuserlocationstart', function (e) {
      var _thisRef$current$prop7, _thisRef$current$prop8;

      (_thisRef$current$prop7 = (_thisRef$current$prop8 = thisRef.current.props).onTrackUserLocationStart) === null || _thisRef$current$prop7 === void 0 ? void 0 : _thisRef$current$prop7.call(_thisRef$current$prop8, e);
    });
    gc.on('trackuserlocationend', function (e) {
      var _thisRef$current$prop9, _thisRef$current$prop10;

      (_thisRef$current$prop9 = (_thisRef$current$prop10 = thisRef.current.props).onTrackUserLocationEnd) === null || _thisRef$current$prop9 === void 0 ? void 0 : _thisRef$current$prop9.call(_thisRef$current$prop10, e);
    });
    return gc;
  }, {
    position: props.position
  });
  thisRef.current.props = props;
  useImperativeHandle(ref, function () {
    return {
      trigger: function trigger() {
        return ctrl.trigger();
      }
    };
  }, []);
  useEffect(function () {
    // @ts-ignore
    applyReactStyle(ctrl._container, props.style);
  }, [props.style]);
  return null;
});
GeolocateControl.displayName = 'GeolocateControl';
export default React.memo(GeolocateControl);